import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: [],
    currentIndex: -1,
    type: null, // 'tracks' | 'mixes'
    // Where the list came from when the type alone is ambiguous ('tracks' is
    // every card list). Analytics-only today: track_play.from = origin || type.
    origin: null, // 'feed' | 'trending' | null
};

const listContextSlice = createSlice({
    name: 'listContext',
    initialState,
    reducers: {
        setListContext(state, action) {
            const { items, currentIndex, type, origin } = action.payload;
            state.items = items || [];
            state.currentIndex = currentIndex ?? -1;
            state.type = type || null;
            state.origin = origin || null;
        },
        setListContextIndex(state, action) {
            state.currentIndex = action.payload;
        },
        clearListContext(state) {
            state.items = [];
            state.currentIndex = -1;
            state.type = null;
            state.origin = null;
        },
    },
});

export const { setListContext, setListContextIndex, clearListContext } = listContextSlice.actions;
export default listContextSlice.reducer;
